export var Severity;
(function(Severity) {
    Severity["HIGH"] = "high";
    Severity["MEDIUM"] = "medium";
    Severity["LOW"] = "low";
})(Severity || (Severity = {}));
